import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClassicCartRepository {
  public legacyV1CartChanged$: Observable<void>;
  private _legacyV1CartChanged: Subject<void>;

  constructor() {
    this._legacyV1CartChanged = new Subject<void>();
    this.legacyV1CartChanged$ = this._legacyV1CartChanged.asObservable();
  }

  triggerLegacyV1CartChanged() {
    this._legacyV1CartChanged.next();
  }
}
